// Component here uses ES6 destructuring syntax in import, what is means is "retrieve the property 'Component' off of the object exported from the 'react'"
import React, {Component, PropTypes} from 'react';
import { stripUnknownProps } from '../../../../utils/reactProps';

// hold style object out here for performance
const verticalScrollbarStyle = {borderRadius: '4px'};

// utility
import _ from 'lodash';
import cx from 'classnames';

// components
import ApplicantCard from './f_ApplicantCard';
import CardFilter from '../../../../common/components/CardFilter';
import ChevronIcon from '../../../../common/svgs/ChevronIcon';

const initState = {
  isFlipped: false,
  checkList: [],
};

class ApplicantsColumn extends Component {
  static propTypes = {
    expandCard: PropTypes.func.isRequired,
    header: PropTypes.string.isRequired,
    applicantsColumn: PropTypes.object,
    applicantStatusKeyedByName: PropTypes.object,
    selectedEmail: PropTypes.string,
    terms: PropTypes.array,
  }

  constructor(props, context) {
    super(props, context);

    this.state.statusList =
    _.reduce(_.keysIn(props.applicantsColumn), (result, status) => {
      result.push({id: _.get(props.applicantStatusKeyedByName, `${status}.id`), name: status});
      return result;
    }, []);
  }

  state = _.assign({}, initState);

  componentWillReceiveProps(nextProps) {
    // Reset filters when resultes changed.
    if(!_.isEqual(nextProps.terms, this.props.terms)) {
      this.setState(_.assign({}, initState));
    }
  }

  onChange(event, newStatusArr) {
    this.setState({
      checkList: newStatusArr
    });
  }

  flipColumn() {
    this.setState({
      isFlipped: !this.state.isFlipped
    });
  }

  render() {
    const {
      header,
      applicantsColumn,
      expandCard,
      selectedEmail,
    } = this.props;

    const applicantsComponentArr = _(applicantsColumn)
      .map(status => _.filter(status, (applicant) => {
        // Filter by statuses.
        if (!_.isEmpty(this.state.checkList) && !~this.state.checkList.indexOf(applicant.profile.applicantStatus.id)) {
          return false;
        }

        return true;
      }).map(applicant => <ApplicantCard key={applicant.user.email}
                           expandCard={expandCard}
                           selectedEmail={selectedEmail}
                           applicant={applicant}/>
      ))
      .flatten()
      .value();

    // flip if state says so
    if(this.state.isFlipped) {
      applicantsComponentArr.reverse();
    }

    return (
      <li className='applicants-column center-column-1' data-id={header}>
        <header className='header-container' onClick={::this.flipColumn}>
          <h3 className='count' data-id={`${header} Count`}>
            {applicantsComponentArr.length}
          </h3>
          <h3 className='header'>
            {header}
          </h3>
          <div className={cx('chevron', {flipped: this.state.isFlipped})} onClick={::this.flipColumn}>
            <ChevronIcon/>
          </div>
          <CardFilter
            search={this.props.terms}
            menuItems={this.state.statusList}
            onChange={::this.onChange}
          />
        </header>
        <div className='applicants-list'
             speed={1}>
          {applicantsComponentArr}
        </div>
      </li>
    );
  }
}


export default ApplicantsColumn;



// WEBPACK FOOTER //
// ./shared/react/r_AdminDashboard/r_ApplicantManager/c_ApplicantsColumn/index.js